import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireContext = require.context('@/assets/img/main', true, /.+-component\.svg$/)
const prefix = 'Svg'

const components = requireContext.keys().map(item => {
  const name = item.replace(/^.+\/(.+)-component.svg$/, '$1')
  const component = require('@/assets/img/main' + item.replace(/^\./, '') + '?inline')

  return [
    prefix + upperFirst(camelCase(name)),
    component
  ]
})

const install = Vue => {
  components.forEach(item => {
    Vue.component(item[0], item[1])
  })
}

Vue.use(install)
